import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './core/auth/auth-guard.service';
import { AuthUserGuardService } from './core/auth/auth-user-guard.service';

const routes: Routes = [
    {
        path: 'sys-admin',
        loadChildren: () => import('./sys-admin/sys-admin.module').then(m => m.SysAdminModule),
        canActivate: [AuthUserGuardService]
    },
    {
        path: 'analysis',
        loadChildren: () => import('./analysis/analysis.module').then(m => m.AnalysisModule),
        canActivate: [AuthUserGuardService]
    },
    {
        path: 'report',
        loadChildren: () => import('./report/report.module').then(m => m.ReportModule),
        canActivate: [AuthGuardService, AuthUserGuardService]
    },
    {
        path: 'useradmin',
        loadChildren: () => import('./user-admin/user-admin.module').then(m => m.UserAdminModule),
        canActivate: [AuthUserGuardService]
    },
    {
        path: 'workstock',
        loadChildren: () => import('./workstock/workstock.module').then(m => m.WorkstockModule),
        canActivate: [AuthGuardService, AuthUserGuardService]
    },
    {
        path: 'dwsm',
        loadChildren: () => import('./dwsm/dwsm.module').then(m => m.DWSMModule),
        canActivate: [AuthGuardService, AuthUserGuardService]
    },
    {
        path: 'welcome',
        loadChildren: () => import('./welcome/welcome.module').then(m => m.WelcomeModule),
        canActivate: [AuthUserGuardService]
    },
    {
        path: 'analysis-search',
        loadChildren: () => import('./analysis-search/analysis-search.module').then(m => m.AnalysisSearchModule),
        canActivate: [AuthGuardService, AuthUserGuardService]
    },
    {
        path: 'archive-search',
        loadChildren: () => import('./archive-search/archive-search.module').then(m => m.ArchiveSearchModule),
        canActivate: [AuthGuardService, AuthUserGuardService]
    },
    {
        path: 'print/:analysisKey/:version',
        loadChildren: () => import('./print/print.module').then(m => m.PrintModule),
        canActivate: [AuthUserGuardService]
    },
    {
        path: 'plannedTvgTime/:analysisKey/:version',
        loadChildren: () => import('./print-planned-tvg-time/print-planned-tvg-time.module').then(m => m.PrintPlannedTvgTimeModule),
        canActivate: [AuthUserGuardService]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })], // use hash other wise when you do /ts/anyurl we get 404 from payara
    exports: [RouterModule]
})
export class AppRoutingModule {}
